import React, { Fragment } from 'react';
import HandoffDefault from '../../containers/handoff/HandoffDefault';
import ScreenAssets from '../../containers/handoff/sidebar/ScreenAssets';
import PanelHeader from './PanelHeader';
export default function Artboard(_a) {
    var title = _a.title, onClose = _a.onClose, isAvaible = _a.isAvaible;
    return isAvaible ? (React.createElement(Fragment, null,
        React.createElement(PanelHeader, { onClose: onClose, title: title }),
        React.createElement(HandoffDefault, null),
        React.createElement(ScreenAssets, null))) : (React.createElement(HandoffDefault, { onClose: onClose }));
}
